import request from '@/utils/request'


export function exportData(data) {
  return request({
    url: 'CheckBreath/exportData',
    method: 'post',
    data
  })
}

export function getPageList(data) {
  return request({
    url: 'CheckBreath/getPageList',
    method: 'post',
    data
  })
}
